<section class="upload-tray" *ngIf="visible()" role="status" aria-live="polite">
  <header class="upload-tray__header">
    <div class="upload-tray__title">
      <span nz-icon nzType="cloud-upload" aria-hidden="true"></span>
      <span>{{ 'fileUpload.tray.title' | translate }}</span>
      <span class="upload-tray__progress" *ngIf="hasActive()">{{
        'fileUpload.tray.percent' | translate: { percent: totalProgress() }
      }}</span>
    </div>
    <button
      *ngIf="hasFinished()"
      nz-button
      nzType="text"
      nzSize="small"
      type="button"
      class="upload-tray__clear  desktop-button"
      (click)="clearFinished()"
      [attr.aria-label]="'fileUpload.tray.clear' | translate"
    >
      <span nz-icon nzType="delete" aria-hidden="true"></span>
    </button>
  </header>

  <ul class="upload-tray__list">
    <li
      *ngFor="let item of items(); trackBy: trackById"
      class="upload-tray__item"
      [class.upload-tray__item--done]="item.status === 'done'"
      [class.upload-tray__item--error]="item.status === 'error'"
    >
      <span class="upload-tray__icon" aria-hidden="true">
        <span nz-icon [nzType]="fileKindIcon(item)"></span>
      </span>

      <div class="upload-tray__body">
        <div class="upload-tray__row">
          <span class="upload-tray__name" [title]="item.fileName">{{ item.fileName }}</span>
          <span class="upload-tray__size">{{ fileSize(item.sizeBytes) }}</span>
        </div>

        <div class="upload-tray__bar" *ngIf="isActive(item.status)">
          <span class="upload-tray__bar-fill" [style.width.%]="item.progress"></span>
        </div>

        <div class="upload-tray__meta" *ngIf="isActive(item.status)">
          <span class="upload-tray__status upload-tray__status--info">
            <ng-container *ngIf="item.status === 'uploading'; else simpleActive">{{
              'fileUpload.tray.uploading_percent' | translate: { percent: item.progress }
            }}</ng-container>
            <ng-template #simpleActive>{{ statusKey(item.status) | translate }}</ng-template>
          </span>
        </div>

        <div class="upload-tray__meta" *ngIf="!isActive(item.status)">
          <span
            class="upload-tray__status"
            [class]="'upload-tray__status--' + statusTone(item.status)"
          >
            <span nz-icon [nzType]="statusIcon(item.status)" aria-hidden="true"></span>
            {{ statusKey(item.status) | translate }}
          </span>
        </div>
      </div>

      <div class="upload-tray__actions">
        <button class="desktop-button"
          *ngIf="isActive(item.status)"
          nz-button
          nzType="text"
          nzSize="small"
          type="button"
          (click)="cancel(item.id)"
          [attr.aria-label]="'fileUpload.tray.cancel' | translate"
        >
          <span nz-icon nzType="close" aria-hidden="true"></span>
        </button>
        <button class="desktop-button"
          *ngIf="item.status === 'error' || item.status === 'canceled'"
          nz-button
          nzType="text"
          nzSize="small"
          type="button"
          (click)="retry(item.id)"
          [attr.aria-label]="'fileUpload.tray.retry' | translate"
        >
          <span nz-icon nzType="reload" aria-hidden="true"></span>
        </button>
        <button class="desktop-button"
          *ngIf="!isActive(item.status)"
          nz-button
          nzType="text"
          nzSize="small"
          type="button"
          (click)="dismiss(item.id)"
          [attr.aria-label]="'fileUpload.tray.dismiss' | translate"
        >
          <span nz-icon nzType="close" aria-hidden="true"></span>
        </button>
      </div>
    </li>
  </ul>
</section>